import { render, staticRenderFns } from "./TwitterIcon.vue?vue&type=template&id=62cd1cc4&scoped=true&"
import script from "./TwitterIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TwitterIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd1cc4",
  null
  
)

export default component.exports